<template>
  <VueSelect
    :input-id="id"
    v-bind="$attrs"
    @update:modelValue="(e) => this.$emit('update:modelValue', e)"
    @search:blur="(e) => this.$emit('search:blur', e)"
    @search="(e, l) => this.$emit('search', e, l)"
    @input="() => {}"
    @change="() => {}"
    @close="() => {}"
  >
   <!--  KV: The purpose of the empty event listeners here is to prevent the surrounding component
     from using these three events to receive a value.  -->
    <template #no-options>
      Ingen resultater
    </template>
  </VueSelect>
</template>
<script>
import VueSelect from 'vue-select';

export default {
  name: "LbVueSelect",
  props: {
    id: {
      type: String,
      default: null
    },
  },
  emits: [
    'update:modelValue', 'search:blur', 'search', 
    'input', 'close', 'change'
  ], 
  components: {
    VueSelect
  },

};
</script>

<style lang="scss">
@use '../../../node_modules/vue-select/dist/vue-select.css';
@import '../../../node_modules/foundation-sites/scss/util/util';
@import '../../styles/settings.scss';
@import '../../styles/colors.scss';
@import '../../styles/typography/fonts.scss';

:root {
  --vs-colors--lightest: rgba(60, 60, 60, 0.26);
  --vs-colors--light: rgba(60, 60, 60, 0.5);
  --vs-colors--dark: #333;
  --vs-colors--darkest: rgba(0, 0, 0, 0.15);

  /* Search Input */
  --vs-search-input-color: inherit;
  --vs-search-input-bg: rgb(255, 255, 255);
  --vs-search-input-placeholder-color: inherit;

  /* Font */
  --vs-font-size: 1rem;
  --vs-line-height: 1.4;

  /* Disabled State */
  --vs-state-disabled-bg: rgb(248, 248, 248);
  --vs-state-disabled-color: var(--vs-colors--light);
  --vs-state-disabled-controls-color: var(--vs-colors--light);
  --vs-state-disabled-cursor: not-allowed;

  /* Borders */
  --vs-border-color: var(--vs-colors--lightest);
  --vs-border-width: 1px;
  --vs-border-style: solid;
  --vs-border-radius: 4px;

  /* Actions: house the component controls */
  --vs-actions-padding: 4px 6px 0 3px;

  /* Component Controls: Clear, Open Indicator */
  --vs-controls-color: var(--vs-colors--light);
  --vs-controls-size: 1;
  --vs-controls--deselect-text-shadow: 0 1px 0 #fff;

  /* Selected */
  --vs-selected-bg: #f0f0f0;
  --vs-selected-color: var(--vs-colors--dark);
  --vs-selected-border-color: var(--vs-border-color);
  --vs-selected-border-style: var(--vs-border-style);
  --vs-selected-border-width: var(--vs-border-width);

  /* Dropdown */
  --vs-dropdown-bg: #fff;
  --vs-dropdown-color: inherit;
  --vs-dropdown-z-index: 1000;
  --vs-dropdown-min-width: 160px;
  --vs-dropdown-max-height: 350px;
  --vs-dropdown-box-shadow: 0px 3px 6px 0px var(--vs-colors--darkest);

  /* Options */
  --vs-dropdown-option-bg: #000;
  --vs-dropdown-option-color: var(--vs-dropdown-color);
  --vs-dropdown-option-padding: 3px 20px;

  /* Active State */
  --vs-dropdown-option--active-bg: #5897fb;
  --vs-dropdown-option--active-color: #fff;

  /* Deselect State */
  --vs-dropdown-option--deselect-bg: #fb5858;
  --vs-dropdown-option--deselect-color: #fff;

  /* Transitions */
  --vs-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  --vs-transition-duration: 150ms;
}

.v-select {
  margin-bottom: rem-calc(15);

  [type='search'] {
    height: rem-calc(30) !important;
    background-color: none;
  }

  &.invalid {
    > div {
      border: 1px solid $input-error-border;
    }
  }

  &.vs--unsearchable {
    [type="search"] {
      background: none;
      height: auto !important;
    }
  }

  .vs__dropdown-toggle {
    background-color: var(--vs-dropdown-bg);

    .vs__selected-options {
      inline-size: 80%;

      input::placeholder {
        color: var(--vs-state-disabled-color);
      }
    }
  }

  .vs__selected {
    white-space: nowrap;
    inline-size: 80%;
    overflow: hidden;
  }

  &.vs--open .vs__selected {
    position: relative;
  }

  &.vs--disabled {

    .vs__dropdown-toggle {
      background-color: var(--vs-state-disabled-bg);
    }

    .vs__selected {
      color: var(--vs-state-disabled-color);
   
    }
  }
}
</style>
